import apiClient from "../../../http-common";
import authHeader from "../../../authentication/authservices/auth-header";

export const saveOPDXMLGenerateForTally = async (obj) => {
  return await apiClient.post("/tally/save/paymentDetailsOPD", obj, {
    headers: authHeader(),
  });
};

export const saveInvXMLGenerateForTally = async (obj) => {
  return await apiClient.post("/tally/save/paymentDetailsInventory", obj, {
    headers: authHeader(),
  });
};

export const saveDoctorBillXMLGenerateForTally = async (obj) => {
  return await apiClient.post("/tally/save/DoctorBill", obj, {
    headers: authHeader(),
  });
};

export const saveDoctorBillBankPaymentXMLGenerateForTally = async (obj) => {
  return await apiClient.post("/tally/save/DoctorBillBankPayment", obj, {
    headers: authHeader(),
  });
};

export const saveOpdCancellationBillXMLGenerarteForTally = async (obj) => {
  return await apiClient.post("/tally/save/OPDCancellation", obj, {
    headers: authHeader(),
  });
};

export const getXMLGenerationTallyList = async () => {
  return await apiClient.get("tally/list/getPaymentDetails", {
    headers: authHeader(),
  });
};

export const deleteXMlData = async (id) => {
  return await apiClient.delete(`/tally/deletePaymentDetailsById/${id}`, {
    headers: authHeader(),
  });
};

export const getFunctionalityDropdown = async () => {
  return await apiClient.get("tally/getFunctionalityDropDown", {
    headers: authHeader(),
  });
};

export const getSubFunctionalityDropdown = async (id) => {
  return await apiClient.get(`tally/getFunctionalityDetailsDropDown/${id}`, {
    headers: authHeader(),
  });
};

//
export const saveIpdBillXMLGenerarteForTally = async (obj) => {
  return await apiClient.post("/tally/save/IPD", obj, {
    headers: authHeader(),
  });
};

export const saveIpdReceiptBillXMLGenerarteForTally = async (obj) => {
  return await apiClient.post("/tally/save/IPDReceipt", obj, {
    headers: authHeader(),
  });
};

export const saveIpdCancellationBillXMLGenerarteForTally = async (obj) => {
  return await apiClient.post("/tally/save/IPDCancellation", obj, {
    headers: authHeader(),
  });
};

export const saveVoucherXMLGenerarteForTally = async (obj) => {
  return await apiClient.post("/tally/save/Contra", obj, {
    headers: authHeader(),
  });
};

export const saveJournalXMLGenerarteForTally = async (obj) => {
  return await apiClient.post("/tally/save/Journal", obj, {
    headers: authHeader(),
  });
};

export const getfunctionalityDropdown = async () => {
  return await apiClient.get(`/tally/getFunctionalityDropDown`, {
    headers: authHeader(),
  });
};

export const getSubfunctionalityDropdown = async (a) => {
  return await apiClient.get(`/tally/getFunctionalityDetailsDropDown/${a}`, {
    headers: authHeader(),
  });
};
export const getAllOPDList = async (obj) => {
  return await apiClient.post(
    `/tally/getAllPaymentDetailsData`,
    {},
    {
      params: obj,
    },
    {
      headers: authHeader(),
    }
  );
};

export const getAllIPDList = async (obj) => {
  return await apiClient.post(
    `/tally/getIPD`,
    {},
    {
      params: obj,
    },
    {
      headers: authHeader(),
    }
  );
};

export const getAllDoctorBillist = async (obj) => {
  return await apiClient.post(
    `/tally/getDoctorBill`,
    {},
    {
      params: obj,
    },
    {
      headers: authHeader(),
    }
  );
};
export const getAllDoctorBilBankPaymentlist = async (obj) => {
  return await apiClient.post(
    `/tally/getDoctorBillBankPayment`,
    {},
    {
      params: obj,
    },
    {
      headers: authHeader(),
    }
  );
};
export const getAllOPDCancellationlist = async (obj) => {
  return await apiClient.post(
    `/tally/getOPDCancellation`,
    {},
    {
      params: obj,
    },
    {
      headers: authHeader(),
    }
  );
};

export const getAllInventoryPharmacylist = async (obj) => {
  return await apiClient.post(
    `/tally/getAllInventoryData`,
    {},
    {
      params: obj,
    },
    {
      headers: authHeader(),
    }
  );
};

export const getPaymentByXMLId = async (id) => {
  return await apiClient.get(`/tally/paymentFindByIdXML/${id}`, {
    headers: authHeader(),
  });
};
